import { Table } from '@platform/ui-library';
import { FC, useMemo } from 'react';
import { useAsync, useDesign, useServices } from '../../../hooks';
import { getIntentLabels } from '../../../utilities';

export const IntentLabelTable: FC = () => {
  const serialized = useDesign();
  const { workflowService } = useServices();
  const {
    components: { intents },
    csvData,
    languages,
    rootSettings: { csvIntentLabelTableId }
  } = serialized;

  const [wfsLanguages] = useAsync(() => workflowService.getLanguages(), []);

  const intentLabels = useMemo(() => {
    // Get language-code to language label map.
    const intentLabels = getIntentLabels(serialized);

    return intents.map(({
      name
    }) => {
      return {
        Name: name,
        ...Object.fromEntries(
          languages.map(({ language }) => {

            return [
              wfsLanguages?.find(({ value }) => value === language)?.label,
              intentLabels.get(name)?.[language] ?? ''
            ];
          })
        )
      };
    });
  }, [csvData, intents, languages, csvIntentLabelTableId, wfsLanguages]);

  return (
    <Table
      data={intentLabels}
    />
  );
};
